import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

const Notification = styled.span`
  background: #ff4e84;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 4px;
  border-radius: 1rem;
  font-size: 0.75rem;
  display: flex;
  align-content: center;
  justify-content: center;
  line-height: 1rem;
  position: absolute;
  font-weight: var(--font-weight-boldest);
  color: #ffffff !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  border: 1px solid var(--color-secondary-hover);
`

function NotificationCount(props) {
  const { count, ...theProps } = props

  const countNum = typeof count === 'string' ? parseInt(count, 10) : count

  if (!countNum) {
    return <></>
  }

  return (
    <Notification {...theProps}>
      {countNum > 99 ? '99+' : countNum}
    </Notification>
  )
}

NotificationCount.defaultProps = {
  count: null,
}

NotificationCount.propTypes = {
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default NotificationCount
